import { GameEngine } from '../GameEngine';
import { Position, PlayerType } from '../types';

interface DebugOverlayProps {
  engine: GameEngine | undefined;
  positions: Record<PlayerType, Position>;
  canvasReady: boolean;
}

const formatNumber = (num: number): string => {
  return num.toFixed(2);
};

export function DebugOverlay({
  engine,
  positions,
  canvasReady,
}: DebugOverlayProps) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 20,
        right: 20,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: '10px',
        borderRadius: '5px',
        zIndex: 1000,
        color: 'white',
      }}
    >
      <div>Status: {engine ? 'Engine Ready' : 'No Engine'}</div>
      <div>Canvas: {canvasReady ? 'Ready' : 'Not Ready'}</div>
      <div>
        Topdown: x:{formatNumber(positions.topdown.x)} y:
        {formatNumber(positions.topdown.y)}
      </div>
      <div>
        Platformer: x:{formatNumber(positions.platformer.x)} y:
        {formatNumber(positions.platformer.y)}
      </div>
    </div>
  );
}
